import { useMemo } from "react";
import {
  formatPriceDisplay,
  formatPriceSimple,
  convertPriceToDisplay,
  convertPriceToServer,
} from "@/utils/price";

/**
 * Хук для работы с ценами
 * Автоматически конвертирует цены из копеек в рубли для отображения
 */
export const usePrice = () => {
  return useMemo(
    () => ({
      /**
       * Конвертирует цену из копеек в рубли для отображения
       */
      toDisplay: convertPriceToDisplay,
      /**
       * Конвертирует цену из рублей обратно в копейки для отправки на сервер
       */
      toServer: convertPriceToServer,
      /**
       * Форматирует цену для отображения (полное форматирование с валютой)
       */
      format: formatPriceDisplay,
      /**
       * Форматирует цену как простую строку "100 ₽"
       */
      formatSimple: formatPriceSimple,
    }),
    []
  );
};
